

export const dynamoItemTypes = <const>[
  'video',
  'image',
  'person',
  'audio',
  'file',

  // Legacy cutter
  'clipList',

  // New cutter
  'timeline',

  'graphics',
];
export type DynamoItemType = typeof dynamoItemTypes[number];

export type SearchItemType = DynamoItemType | 'folder';

export const ItemType = {
  VIDEO: 'video',
  IMAGE: 'image',
  PERSON: 'person',
  AUDIO: 'audio',
  FILE: 'file',
  FOLDER: 'folder',

  // Legacy cutter
  CLIP_LIST: 'clipList',

  // New cutter
  TIMELINE: 'timeline',

  GRAPHICS: 'graphics',
} as const;

export const searchItemTypeList: SearchItemType[] = [
  'video',
  'image',
  'person',
  'audio',
  'file',
  'clipList',
  'timeline',
  'folder',
  'graphics',
];

export function isSearchItemType(val: string): val is SearchItemType {
  return searchItemTypeList.includes(val as any);
}
